import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoImg from '../img/newlogo.png';

function Register() {
    const [documentNumber, setDocumentNumber] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Guardamos el documento en localStorage para usarlo en el siguiente paso
        localStorage.setItem('registerDocument', documentNumber);
        navigate('/registro/datos');
    };

    const handleDocumentChange = (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setDocumentNumber(value);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <img src={logoImg} alt="Logo" className="login-logo" />
                <h2>Ingresá tu DNI o CUIT de la empresa</h2>

                <div className="document-info">
                    <p className="document-description">
                        El documento con el que tenes asociado tu negocio. Al finalizar el registro será redirigido a tu cuenta de Mercado Pago para empezar a consultar las transferencias recibidas.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="register-form">
                    <div className="input-container">
                        <input
                            type="text"
                            value={documentNumber}
                            onChange={handleDocumentChange}
                            className="register-input"
                            placeholder="Ingresá solo números"
                            maxLength="11"
                            required
                        />
                        <p className="input-helper">Ingresá solo números, sin puntos, espacios ni guiones.</p>
                    </div>

                    <button type="submit" className="register-button">
                        Continuar
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Register; 